import { graphql } from "react-relay";

export const DELETE_STACK_RULE = graphql`
  mutation DeleteStackRuleMutation($input: DeleteStackRuleInput!) {
    deleteStackRule(input: $input) {
      success
    }
  }
`;
